import {h, Fragment} from "preact"
import { useFacet, useProductFilters } from "@nosto/preact"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"
import { useState, useEffect } from "preact/hooks";
import ShowMoreFacetButton from "./elements/ShowMoreFacetButton"

export default function Facet({ facet, isDesktop, isSearch }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet);
    const { filters, removeAll } = useProductFilters();
    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };
    const [filtersOfFacet, setFiltersOfFacet] = useState([]);
    
    const facetValues = !showAll && isDesktop && !isSearch ? facet.data?.slice(0, 10) : facet.data;

    useEffect(()=>{
        // Update the filtersOfFacet state whenever the filters change
        const updatedFilters = filters.filter(filter => filter.field === facet.field);
        setFiltersOfFacet(updatedFilters);
    }, [filters]);

    function removeAllFiltersOfFacet() {
        if(!filtersOfFacet.length) return;
        filtersOfFacet.forEach(filter => {
            toggleProductFilter(filter.field, filter.value, false);
        });
    }
    // console.log(filtersOfFacet);
    useEffect(()=>{
        if(active && !isDesktop && isSearch){
            toggleActive();
        }
    }, [])
    useEffect(()=>{
        if(!active && isDesktop){
            toggleActive();
        }
    },[])
    return (
        <li class={`ns-sidebar-dropdown ${active ? "ns-active" : ""}`} aria-expanded={!!active}>
            <span
                class="ns-anchor ns-d-inline-flex ns-relative ns-w-100 ns-border-box"
                data-nosto-element="facet"
                onClick={toggleActive}
                aria-controls={`${facet.id}-sub-menu`}
                aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
            >
                <span class="ns-font-1 ns-facet-name">{facet.name}</span>
                {selectedFiltersCount > 0 && !isSearch ? (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-1 ns-ml-1">
                        ({selectedFiltersCount})
                    </span>
                ): ''}
                {/* <Icon name="arrow" className="ns-absolute" /> */}
                {isSearch && !isDesktop ? (
                    <svg class="nosto__filter-option-icon" xmlns="http://www.w3.org/2000/svg" width="7" height="12" role="img" aria-label={`Filter by: ${facet?.name}`} viewBox="0 0 7 12" fill="#222">
                    <path class="nosto__filter-option-path" d="M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z"></path>
                  </svg>
                ) : (
                    <>
                        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                            </path>
                        </svg>
                        <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                            </path>
                        </svg>
                    </>
                )}
                
                {isSearch && isDesktop && filtersOfFacet?.length > 0 ? (
                    <span class="ns-clear-specific-facet ns-font-1" onClick={removeAllFiltersOfFacet}>Clear</span>
                ) : ''}
            </span>
            {isSearch && !isDesktop && filtersOfFacet?.length > 0 ? (
                    <div class="nosto__filter-option-mobile-items-selected">{
                        filtersOfFacet.map(filter => filter.value).join(',')
                    }</div>
            ) : ''}
            <div class="ns-sidebar-submenu ns-d-none" id={`${facet.id}-sub-menu`}>
                <span
                    class="ns-anchor ns-d-inline-flex ns-relative ns-w-100 ns-border-box"
                    data-nosto-element="facet"
                    onClick={toggleActive}
                    aria-controls={`${facet.id}-sub-menu`}
                    aria-label={`${active ? 'Collapse' : 'Expand' } ${facet.name}`}
                >
                    {isSearch ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none" role="img" aria-label="Close">
                            <path d="M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z" fill="#222222"></path>
                        </svg>
                    ) : (
                        <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                            </path>
                        </svg>
                    )}
                    <span class="ns-font-1 ns-facet-name">{facet.name}</span>
                    <div class="ns-d-block">
                        {isSearch && !isDesktop && filtersOfFacet?.length > 0 ?(
                            <span class="ns-clear-specific-facet ns-font-1" onClick={(e)=>{
                                e.stopPropagation();
                                removeAllFiltersOfFacet();
                            }}>Clear</span>
                        ) : ''}
                    </div>
                    {/* {selectedFiltersCount > 0 && (
                        <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-1 ns-ml-1">
                            ({selectedFiltersCount})
                        </span>
                    )} */}
                    {/* <Icon name="arrow" className="ns-absolute" /> */}
                    {/* <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                        </path>
                    </svg>
                    <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
                        </path>
                    </svg> */}
                </span>
                <ul class="ns-list-unstyled ns-p-0 ns-m-0" role="menu">
                    {facetValues?.map(value => (
                        
                            <li
                                key={value.value}
                                class="ns-d-flex ns-align-items-center ns-font-1"
                                data-nosto-element="facet-setting"
                                role="menuitem"
                            >
                                <Checkbox
                                    value={value.value}
                                    selected={value.selected}
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}
                                />
                                <span class="ns-count ns-d-inline-block ns-text-align-center ns-font-1 ns-ml-1">
                                    ({value.count})
                                </span>
                            </li>
                        
                    ))}
                </ul>
            </div>
            {facet.data?.length > 10 && <ShowMoreFacetButton active={active} toggleShowAll={toggleShowAll} showAll={showAll}/>}
        </li>
    )
}
